// extracted by mini-css-extract-plugin
module.exports = {"perk":"_2obIO8W18dBpBkg1WpHVDm","text":"_2mGQt5qhFJWQH0ID1l5lIJ","title":"_3e9Tg-miP2U4yTl6r0Rzrv"};